import { HI_STATUS, HI_STATUS_LABEL } from '../config/status';

export function getHINameByValue(val: number) {
  if (!(val in HI_STATUS_LABEL)) {
    return HI_STATUS_LABEL[HI_STATUS.NO_DATA];
  }
  return HI_STATUS_LABEL[val];
}
export function getHIValueByName(val: string): number {
  if (!(val in HI_STATUS)) {
    return HI_STATUS.NO_DATA;
  }
  return HI_STATUS[val];
}